const validatePostalCode = (value: string) => {
  if (!value) return value;

  // Remove any non-digit characters
  const digitsOnly = value.replace(/\D/g, '');

  // Limit to 5 digits
  return digitsOnly.slice(0, 5);
};

export default validatePostalCode;
